import PropTypes from 'prop-types';

export default class EdocatButton extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
    primary: PropTypes.bool,
    disabled: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.array, PropTypes.func]),
  };

  static defaultProps = {
    className: '',
    primary: false,
    disabled: false,
  };

  render() {
    const { className, label, href, onClick, primary, disabled } = this.props;

    return (
      <span
        className={`${className} yui-button yui-push-button ${primary ? 'alf-primary-button' : ''} ${
          disabled ? 'disabled' : ''
        }`}
      >
        <span className="first-child">
          {label && (
            <a href={href || '#'} onClick={onClick}>
              {label}
            </a>
          )}
          {!label && this.props.children}
        </span>
      </span>
    );
  }
}
